import React from 'react';
import { Fab, withStyles } from '@material-ui/core';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './styles';

const PF2MSearchButton = ({
  onClick,
  disabled,
  classes,
  ...props
}) => {
  const { t: translate } = useTranslation();

  return (
    <Fab
      variant="extended"
      color="secondary"
      size="large"
      onClick={onClick}
      disabled={disabled}
      className={classes.button}
      {...props}
    >
      <SearchOutlined className={classes.icon} />
      {translate('common:Search').toUpperCase()}
    </Fab>
  );
};

PF2MSearchButton.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.any,
};

PF2MSearchButton.defaultProps = {
  classes: {},
  disabled: false,
  onClick: () => {},
};

export default withStyles(styles)(PF2MSearchButton);
